import(/* webpackMode: "eager" */ "/home/devteam/haritweg/frontend/src/app/[locale]/login/page.js");
